module.exports = __webpack_public_path__ + "static/react-navigation-icon-7afd949aaeb6441d93ed9d3bd0855332.svg";